import { apiClient } from './client'
import type {
  EarningsCalendarResponse,
  EarningsHistoryResponse,
  EarningsSummaryResponse,
  EarningsRefreshResponse,
} from '../types/earnings'

const BASE_PATH = '/api/earnings'

// Calendar API
export const earningsCalendarApi = {
  get: async (daysAhead: number = 90): Promise<EarningsCalendarResponse> => {
    const response = await apiClient.get<EarningsCalendarResponse>(
      `${BASE_PATH}/calendar`,
      { params: { days_ahead: daysAhead } }
    )
    return response.data
  },
}

// History API
export const earningsHistoryApi = {
  get: async (symbol: string, limit: number = 20): Promise<EarningsHistoryResponse> => {
    const response = await apiClient.get<EarningsHistoryResponse>(
      `${BASE_PATH}/history/${encodeURIComponent(symbol)}`,
      { params: { limit } }
    )
    return response.data
  },
}

// Summary API
export const earningsSummaryApi = {
  get: async (symbol: string): Promise<EarningsSummaryResponse> => {
    const response = await apiClient.get<EarningsSummaryResponse>(
      `${BASE_PATH}/summary/${encodeURIComponent(symbol)}`
    )
    return response.data
  },
}

// Refresh API (Admin)
export const earningsRefreshApi = {
  refreshCalendar: async (symbols?: string[]): Promise<EarningsRefreshResponse> => {
    const response = await apiClient.post<EarningsRefreshResponse>(
      `${BASE_PATH}/refresh`,
      null,
      { params: symbols ? { symbols: symbols.join(',') } : undefined }
    )
    return response.data
  },

  refreshSymbol: async (symbol: string): Promise<EarningsRefreshResponse> => {
    const response = await apiClient.post<EarningsRefreshResponse>(
      `${BASE_PATH}/${encodeURIComponent(symbol)}/refresh`
    )
    return response.data
  },
}
